import meta from "../../../pages/_meta.js";
import getting_started_meta from "../../../pages/getting-started/_meta.js";
import guides_meta from "../../../pages/guides/_meta.js";
export const pageMap = [{
  data: meta
}, {
  name: "404",
  route: "/404",
  frontMatter: {
    "sidebarTitle": "404"
  }
}, {
  name: "faq",
  route: "/faq",
  frontMatter: {
    "title": "FAQ",
    "description": "Pluto — The API for personal web data. Embed it in your app to authenticate users, share data and perform actions on their behalf for any site on the internet."
  }
}, {
  name: "getting-started",
  route: "/getting-started",
  children: [{
    data: getting_started_meta
  }, {
    name: "authenticated-automations",
    route: "/getting-started/authenticated-automations",
    frontMatter: {
      "title": "Authenticated Automations",
      "description": "Pluto — The API for personal web data. Embed it in your app to authenticate users, share data and perform actions on their behalf for any site on the internet."
    }
  }, {
    name: "example-github-repo",
    route: "/getting-started/example-github-repo",
    frontMatter: {
      "title": "Example Github Repo",
      "description": "Pluto — The API for personal web data. Embed it in your app to authenticate users, share data and perform actions on their behalf for any site on the internet."
    }
  }, {
    name: "first-automation",
    route: "/getting-started/first-automation",
    frontMatter: {
      "title": "First Automation",
      "description": "Pluto — The API for personal web data. Embed it in your app to authenticate users, share data and perform actions on their behalf for any site on the internet."
    }
  }]
}, {
  name: "guides",
  route: "/guides",
  children: [{
    data: guides_meta
  }, {
    name: "advanced-automation",
    route: "/guides/advanced-automation",
    frontMatter: {
      "title": "Advanced Automation Guide",
      "description": "Pluto — The API for personal web data. Embed it in your app to authenticate users, share data and perform actions on their behalf for any site on the internet."
    }
  }, {
    name: "automation-sdk",
    route: "/guides/automation-sdk",
    frontMatter: {
      "title": "Using the Pluto Automation SDK",
      "description": "Pluto — The API for personal web data. Embed it in your app to authenticate users, share data and perform actions on their behalf for any site on the internet."
    }
  }, {
    name: "blockchain-verification",
    route: "/guides/blockchain-verification",
    frontMatter: {
      "title": "Blockchain Verification",
      "description": "Pluto — The API for personal web data. Embed it in your app to authenticate users, share data and perform actions on their behalf for any site on the internet."
    }
  }, {
    name: "stealth-headless-browsers",
    route: "/guides/stealth-headless-browsers",
    frontMatter: {
      "title": "Stealth Headless Browsers",
      "description": "Pluto - The API for personal web data. Embed it in your app to authenticate users, share data and perform actions on their behalf for any site on the internet."
    }
  }, {
    name: "using-playwright",
    route: "/guides/using-playwright",
    frontMatter: {
      "title": "Using Playwright (TEE Mode)",
      "description": "Pluto — The API for personal web data. Embed it in your app to authenticate users, share data and perform actions on their behalf for any site on the internet."
    }
  }, {
    name: "using-server-side-sdk",
    route: "/guides/using-server-side-sdk",
    frontMatter: {
      "title": "Using the Server Side SDK",
      "description": "Pluto — The API for personal web data. Embed it in your app to authenticate users, share data and perform actions on their behalf for any site on the internet."
    }
  }, {
    name: "using-the-javascript-sdk",
    route: "/guides/using-the-javascript-sdk",
    frontMatter: {
      "title": "Using the Pluto Frame SDKs",
      "description": "Pluto — The API for personal web data. Embed it in your app to authenticate users, share data and perform actions on their behalf for any site on the internet."
    }
  }, {
    name: "using-the-mobile-sdk",
    route: "/guides/using-the-mobile-sdk",
    frontMatter: {
      "title": "Using the Mobile SDKs",
      "description": "Pluto — The API for personal web data. Embed it in your app to authenticate users, share data and perform actions on their behalf for any site on the internet."
    }
  }]
}, {
  name: "index",
  route: "/",
  frontMatter: {
    "title": "Introduction",
    "description": "Pluto — The API for personal web data. Embed it in your app to authenticate users, share data and perform actions on their behalf for any site on the internet."
  }
}, {
  name: "other-resources",
  route: "/other-resources",
  frontMatter: {
    "title": "Other Resources",
    "description": "Pluto — The API for personal web data. Embed it in your app to authenticate users, share data and perform actions on their behalf for any site on the internet."
  }
}, {
  name: "verify-proofs",
  route: "/verify-proofs",
  frontMatter: {
    "title": "Verify Proofs",
    "description": "Pluto — The API for personal web data. Embed it in your app to authenticate users, share data and perform actions on their behalf for any site on the internet."
  }
}];